var __vue_script__, __vue_template__
var __vue_styles__ = {}
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=_v-6356f3a3&scoped=true!../../../node_modules/vue-loader/lib/selector.js?type=style&index=0!../../../node_modules/eslint-loader/index.js!./boardVisorSmall.vue")
__vue_script__ = require("!!babel-loader?presets[]=es2015&plugins[]=transform-runtime&comments=false!../../../node_modules/vue-loader/lib/selector.js?type=script&index=0!../../../node_modules/eslint-loader/index.js!./boardVisorSmall.vue")
if (Object.keys(__vue_script__).some(function (key) { return key !== "default" && key !== "__esModule" })) {
  console.warn("[vue-loader] src\\components\\game\\boardVisorSmall.vue: named exports in *.vue files are ignored.")}
__vue_template__ = require("!!vue-html-loader!../../../node_modules/vue-loader/lib/template-rewriter.js?id=_v-6356f3a3!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!../../../node_modules/eslint-loader/index.js!./boardVisorSmall.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
if (__vue_template__) {
__vue_options__.template = __vue_template__
}
if (!__vue_options__.computed) __vue_options__.computed = {}
Object.keys(__vue_styles__).forEach(function (key) {
var module = __vue_styles__[key]
__vue_options__.computed[key] = function () { return module }
})



//////////////////
// WEBPACK FOOTER
// ./src/components/game/boardVisorSmall.vue
// module id = 64
// module chunks = 11